import Collapse from 'bootstrap/js/dist/collapse'; // for elLinked 

import Swiper, {  Lazy, Keyboard } from 'swiper';

Swiper.use([  Lazy, Keyboard]);




const sliderLinked = () => {

  const sliders = document.querySelectorAll('.swiper-legend');
  sliders.forEach(slider => {
    // add data-linked attribute on the slider
    const selectorLinked = slider.getAttribute('data-linked');
    const elLinked = document.querySelector(selectorLinked);

    const dataParentId = elLinked.getAttribute('data-parent-id')

    new Swiper(slider, {
      loop: true,
      grabCursor: true,
      slidesPerView: 1,
      autoHeight: true,
      initialSlide: 0,
      preloadImages: false,
      // Enable lazy loading
      lazy: {
        loadPrevNext: true,
      },
      on: {
        slideChange: function () {
          let realIndex = this.realIndex + 1;
          let legend = elLinked.querySelector('#accordion-collapse-' + dataParentId + '-' + realIndex);
          new Collapse(legend, {
            toggle: true
          })
        },
        init: function () {
          for (const child of elLinked.children) {
            child.addEventListener('click', (event) => {
              let sliderIndex = event.target.getAttribute('data-slide');  // get slide number and slide to it        
              if (sliderIndex) {
                this.slideTo(sliderIndex);
              }
            });
          };
        },
      },

    })
  });

}

export default sliderLinked;

